import { cloneDeep } from 'lodash';
import { GlobalBanner } from '@portal/types/studio/banner';

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '\\*');
};

export const applyBannerReplacements = (content: any, activeBanner: GlobalBanner | undefined) => {
  if (!activeBanner) return content;

  // Create deep copy to avoid mutations
  let transformedContent = cloneDeep(content);

  // Apply text replacements
  if (activeBanner.textReplacements?.length) {
    const replaceInObject = (obj: any): any => {
      if (typeof obj === 'string') {
        let result = obj;
        activeBanner.textReplacements?.forEach((replacement) => {
          if (replacement.find && replacement.replace) {
            // Escape special regex characters in the find string
            const escapedFind = escapeRegExp(replacement.find);
            result = result.replace(new RegExp(escapedFind, 'g'), replacement.replace);
          }
        });
        return result;
      }

      if (Array.isArray(obj)) {
        return obj.map((item) => replaceInObject(item));
      }

      if (typeof obj === 'object' && obj !== null) {
        const newObj: Record<string, any> = {};
        Object.entries(obj).forEach(([key, value]) => {
          newObj[key] = replaceInObject(value);
        });
        return newObj;
      }

      return obj;
    };

    transformedContent = replaceInObject(transformedContent);
  }

  // Apply section replacements
  if (activeBanner.sectionReplacements?.length) {
    // Check if we're dealing with a single section or an array of sections
    if (transformedContent._type?.startsWith('offer')) {
      // Single section case
      const sharedSection = activeBanner.sectionReplacements[0]?.replacement;
      if (sharedSection?.sections?.[0]) {
        transformedContent = {
          ...sharedSection.sections[0],
          _key: transformedContent._key
        };
      }
    } else if (transformedContent.sections && Array.isArray(transformedContent.sections)) {
      // Array of sections case
      transformedContent = {
        ...transformedContent,
        sections: transformedContent.sections.map((section: any) => {
          if (section._type?.startsWith('offer')) {
            const sharedSection = activeBanner.sectionReplacements[0]?.replacement;
            if (sharedSection?.sections?.[0]) {
              return {
                ...sharedSection.sections[0],
                _key: section._key
              };
            }
          }
          return section;
        })
      };
    }
  }

  return transformedContent;
};
